import React from 'react';

const SignalHoverPopup = ({ signalHover, onMouseEnter, onMouseLeave, onAddLabel, onClose }) => {
  if (!signalHover) return null;

  return (
    <div
      className="leg-signal-popup"
      style={{ left: signalHover.clientX + 14, top: signalHover.clientY - 18 }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="leg-signal-row">
        <span className="leg-signal-meta">Date</span>
        <span className="leg-signal-val">
          {signalHover.ts
            ? new Date(signalHover.ts * 1000).toLocaleDateString('fr-FR', {
                day: '2-digit', month: 'short', year: 'numeric',
              })
            : '—'}
        </span>
      </div>
      <div className="leg-signal-row">
        <span className="leg-signal-meta">Valeur</span>
        <span className="leg-signal-val leg-signal-val--bold">
          {signalHover.yVal !== undefined
            ? `${Math.round(signalHover.yVal * 10) / 10}`
            : '—'}
        </span>
      </div>
      {onAddLabel && (
        <button
          className="leg-btn-add-signal"
          onClick={() => {
            onAddLabel({ ts: signalHover.ts, yVal: signalHover.yVal, curveIndex: signalHover.curveIndex });
            onClose?.();
          }}
        >
          + Ajouter un label
        </button>
      )}
    </div>
  );
};

export default SignalHoverPopup;
